import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import SearchHistory from './SearchHistory';
import ReccomendedSection from './RecommendedSection';

export default function GameSearchModalDefaultContent() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <p className={styles.container__text}>{t('sports_search_constraint')}</p>
      <SearchHistory />

      <div className={styles['container__hide-mobile']}>
        <ReccomendedSection />
      </div>
    </div>
  );
}
